import { render, staticRenderFns } from "./PaymentCardStatusBox.vue?vue&type=template&id=2f690d33&scoped=true&lang=pug"
import script from "./PaymentCardStatusBox.vue?vue&type=script&lang=js"
export * from "./PaymentCardStatusBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f690d33",
  null
  
)

export default component.exports